import { render } from "./form-chat.vue?vue&type=template&id=3951c6f5&scoped=true"
import script from "./form-chat.vue?vue&type=script&lang=js"
export * from "./form-chat.vue?vue&type=script&lang=js"

import "./form-chat.vue?vue&type=style&index=0&id=3951c6f5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3951c6f5"]])

export default __exports__